import { Avatar, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { PlexSummaryChangeEventFragment, useGetLoggedInUserQuery } from '../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';
import { PostDate } from '../common/PostDate';
import { getActionText, getTargetName, useGetOnClickChangeEvent } from './NotificationsView/utils';

interface Props {
  event: PlexSummaryChangeEventFragment;
  className?: string;
  onClick?: () => void;
}

export const ChangeEvent = React.memo(({ className, event, onClick }: Props): React.ReactElement | null => {
  const classes = useStyles();
  const eventOnClick = useGetOnClickChangeEvent(event);
  const loggedInUser = useGetLoggedInUserQuery({ variables: {} });

  return (
    <div
      className={classNames(classes.root, className)}
      onClick={(): void => {
        if (!!eventOnClick) {
          eventOnClick();
        }
        if (!!onClick) {
          onClick();
        }
      }}
    >
      <Avatar className={classes.avatar} src={event.author.picture} alt={event.author.name} />
      <div className={classes.content}>
        <div className={classes.authorContainer}>
          <PlexTypography className={classes.authorName} text={event.author.name} size={TextSizesEnum.Normal} />
          <PostDate
            className={classes.eventDate}
            prefix={'• '}
            size={TextSizesEnum.Normal}
            date={new Date(event.createdAt)}
          />
        </div>
        <PlexTypography
          className={classes.eventActionText}
          text={getActionText(event, loggedInUser.data?.currentUser?.email)}
          size={TextSizesEnum.Normal}
        />
        <PlexTypography text={getTargetName(event)} size={TextSizesEnum.Normal} className={classes.eventText} />
      </div>
    </div>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: spacings.normal,
    cursor: 'pointer',
  },
  avatar: {
    display: 'flex',
    marginRight: spacings.small,
    width: 40,
    height: 40,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacings.normal,
  },
  authorContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  authorName: {
    color: colorPalette.purpleGray._500,
    fontWeight: 'bold',
  },
  eventDate: {
    color: colorPalette.purpleGray._400,
  },
  eventActionText: {
    color: colorPalette.purpleGray._500,
    marginTop: spacings.xsmall,
  },
  eventText: {
    color: colorPalette.dark._900,
    marginTop: spacings.normal,
  },
}));
